module.exports = __webpack_public_path__ + "img/net_logo.375cb943.png";